import { useLocation } from 'react-router-dom'
import { getLang } from '@/lib/lang'
import { blocksUiFor } from '@/data/blocks.en'
/** Source: public/design-patterns.html (shared catalog markup helpers). */
import { Picture } from '../Picture'

export function BlockPicture({ src, alt, className }: { src?: string; alt?: string; className?: string }) {
  if (!src) return null // Yuichi「画像が枠だけで表示されない」: 画像なしは空枠を描かない
  return <Picture src={src} alt={alt ?? ''} className={className} />
}

/** 金額。EN ページでは ¥ 前置 + 英語の単位(suffix は JA 表記のまま渡してよい。ここで置換する) */
export function Yen({ value, suffix = '円(税込)' }: { value: number; suffix?: string }) {
  const lang = getLang(useLocation().pathname)
  if (lang === 'ja') return <>{value.toLocaleString('ja-JP')}<small>{suffix}</small></>
  const t = blocksUiFor(lang)
  const en = suffix.replace('円〜(税込)', t.yenFrom).replace('円(税込)', t.yen).replace('・仮価格', t.provisionalPlan).replace(/・/g, ' · ')
  return <>¥{value.toLocaleString('en-GB')}<small>{en}</small></>
}
